var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fund-badge-container",style:(`height: ${_vm.size}px; width: ${_vm.size}px; min-width: ${_vm.size}px;`)},[_c('v-icon',{staticClass:"fund-badge",style:(`background-color: ${_vm.fundColor}`),attrs:{"dark":"","size":`${_vm.iconSize}px`}},[_vm._v(" "+_vm._s(_vm.fundIcon)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }